"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.actionCreators = void 0;
exports.actionCreators = {
    requestFunction: function (pageload, uuid, service, token) { return function (dispatch, getState) {
        var appState = getState();
        if (appState && appState.keyToken && pageload == true) {
            fetch("/v1/token/apps/" + uuid + "/services/" + service + "/keys/" + token + "/tokens", {
                method: 'GET'
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                dispatch({ type: 'RECEIVE_TOKEN', model: data });
            })
                .then(function (error) {
            });
            dispatch({ type: 'REQUEST_TOKEN' });
        }
    }; }
};
var unloadedState = { isLoading: false, response: undefined };
var reducer = function (state, incomingAction) {
    if (state === undefined) {
        return unloadedState;
    }
    var action = incomingAction;
    switch (action.type) {
        case 'REQUEST_TOKEN':
            return {
                isLoading: false,
            };
        case 'RECEIVE_TOKEN':
            return {
                isLoading: true,
                response: action.model
            };
        default: return state;
    }
};
exports.reducer = reducer;
//# sourceMappingURL=KeyTokenByUUIDAndSerIDAndTokenId.js.map